var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Room, StatusBoundary, videoCallService, } from 'hx-twilio-video';
import { createAsyncResource } from 'hx-util';
import { CircularProgress, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
var AsyncResource = createAsyncResource();
var getRoomToken = videoCallService.getRoomToken;
var STAGING_ROOM_NAME = 'roomname';
export var VideoCallPage = function () {
    var navigate = useNavigate();
    var speakToAnExpertForm = useSelector(function (state) { return state.speakToAnExpertForm; });
    var queryOptions = {
        queryKey: ['getRoomToken'],
        queryFn: function () {
            return getRoomToken({
                room: STAGING_ROOM_NAME,
                firstName: speakToAnExpertForm['first-name'],
                lastName: speakToAnExpertForm['last-name'],
                contactNumber: speakToAnExpertForm['contact-number'],
            });
        },
    };
    return (_jsx(StatusBoundary, __assign({ fallback: _jsxs("div", __assign({ className: "grid gap-4 min-h-widget place-content-center place-items-center" }, { children: [_jsx(CircularProgress, {}), _jsx(Typography, __assign({ variant: "info" }, { children: "Connecting to room..." }))] })) }, { children: _jsx(AsyncResource, __assign({ queryOptions: queryOptions }, { children: _jsx(Room, { voiceOnly: true, roomName: STAGING_ROOM_NAME, onDisconnected: function () { return navigate('/selection'); } }) })) })));
};
